import { useEffect, useState } from "react";
import StepStateFormWidget from "../../Widgets/step-state-form/StepStateFormWidget";
import FillInformationSection from "./fill-information-section";
import HealthAssessmentSection from "./health-assessment-section";
import ButtonStepFormWidget from "../../Widgets/button-step-form/ButtonStepFormWidget";
import "../../Style/form-submit/form.css";
import OtpDialogWidget from "../../Widgets/otp-dialog/OtpDialogWidget";
import ConfirmInformationSection from "./confirm-information-section";
import PaymentSection from "../payment/payment-section";
import { isNullOrEmpty } from "../../Services/service";
import { getDistrict, getOccupation, getProvince, getWard, previousStep } from "../../Services/api-service";
import EkycSection from "../ekyc/ekyc-section";

function Form({ objectDto, setObjectDto, setIsLoading, imgBack, imgFront, setImgBack, setImgFront }) {
  const [stateButtonStep, setStateButtonStep] = useState(false);
  const [province, setProvince] = useState([]);
  // const [district, setDistrict] = useState([]);
  const [ward, setWard] = useState([]);
  // const [contactDistrict, setContactDistrict] = useState([]);
  const [contactWard, setContactWard] = useState([]);
  const [occupation, setOccupation] = useState([]);
  const [changeEmail, setChangeEmail] = useState(false);
  const renderStep = () => {
    switch (objectDto.step) {
      case 2:
        return (
          <HealthAssessmentSection
            objectDto={objectDto}
            setState={setStateButtonStep}
            setObjectDto={setObjectDto}
          />
        );

      case 3:
        return (
          <FillInformationSection
          objectDto={objectDto}
          setObjectDto={setObjectDto}
          // contactDistrict={contactDistrict}
          contactWard={contactWard}
          // district={district}
          occupation={occupation}
          province={province}
          // setContactDistrict={setContactDistrict}
          setContactWard={setContactWard}
          // setDistrict={setDistrict}
          changeEmail={changeEmail}
          setLoading={setIsLoading}
          setWard={setWard}
          ward={ward}
          imgBack={imgBack}
          imgFront={imgFront}
          setImgBack={setImgBack}
          setImgFront={setImgFront}
          />
        );
      case 4:
        return (
          <>
            <FillInformationSection
              objectDto={objectDto}
              setObjectDto={setObjectDto}
              // contactDistrict={contactDistrict}
              contactWard={contactWard}
              // district={district}
              occupation={occupation}
              setLoading={setIsLoading}
              province={province}
              // setContactDistrict={setContactDistrict}
              setContactWard={setContactWard}
              // setDistrict={setDistrict}
              changeEmail={changeEmail}
              setWard={setWard}
              ward={ward}
              imgBack={imgBack}
              imgFront={imgFront}
              setImgBack={setImgBack}
              setImgFront={setImgFront}
            />
            <OtpDialogWidget setIsLoading={setIsLoading}
              objectDto={objectDto}
              setObjectDto={setObjectDto}
              imgBack={imgBack}
              imgFront={imgFront}
              setChangeEmail={setChangeEmail}
              onClose={()=>previousStep(objectDto, setObjectDto, setIsLoading)}
            />
          </>
        );
      case 5:
        return (
          <ConfirmInformationSection
            objectDto={objectDto}
            setObjectDto={setObjectDto}
            // contactDistrict={contactDistrict}
            contactWard={contactWard}
            // district={district}
            occupation={occupation}
            province={province}
            setState={setStateButtonStep}
            ward={ward}
          />
        );
      case 6: 
        return (
          <EkycSection 
          objectDto={objectDto}
          // contactDistrict={contactDistrict}
          contactWard={contactWard}
          // district={district}
          occupation={occupation}
          province={province}
          ward={ward}
          setLoading={setIsLoading}
          setObjectDto={setObjectDto}
          />
        );
      case 7:
        return (
          <PaymentSection 
          objectDto={objectDto}
          // contactDistrict={contactDistrict}
          contactWard={contactWard}
          // district={district}
          occupation={occupation}
          province={province}
          ward={ward}/>
        )
      default:
        return <></>;
    }
  };
  useEffect(()=>{
    getProvince(setProvince);
    getOccupation(setOccupation);
    // if(!isNullOrEmpty(objectDto.provinceCode)){
    //   getDistrict(objectDto.provinceCode, setDistrict, setIsLoading);
    // }
    // if(!isNullOrEmpty(objectDto.contactProvinceCode)){
    //   getDistrict(objectDto.contactProvinceCode, setContactDistrict, setIsLoading);
    // }
    if(!isNullOrEmpty(objectDto.provinceCode)){
      getWard(objectDto.provinceCode, setWard, setIsLoading);
    }
    if(!isNullOrEmpty(objectDto.contactProvinceCode)){
      getWard(objectDto.contactProvinceCode, setContactWard, setIsLoading);
    }
  },[])
  return (
    <div className="form-submit-container">
      <StepStateFormWidget objectDto={objectDto} />
      {renderStep()}
      <ButtonStepFormWidget
        setIsLoading={setIsLoading}
        objectDto={objectDto}
        setObjectDto={setObjectDto}
        state={stateButtonStep}
        imgBack={imgBack}
        imgFront={imgFront}
        setState={setStateButtonStep}
      />
    </div>
  );
}
export default Form;
